import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NewGame } from '../../../shared/components/forms/new-game/new-game';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AllStatus } from '../../../core/services/status/all-status';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ExitService } from '../../../core/services/exit/exit.service';
import { DowntimeWindow } from '../../../shared/dialogs/downtime-window/downtime-window';
import { exhaustMap, Subscription, take, tap } from 'rxjs';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { NewGameService } from '../../../shared/services/games/new-game';
import { PlayersService } from '../../../shared/services/players/players';
import { NotificationService } from '../../../core/services/Notification/notification';
import { ListQuest } from '../../../shared/services/lists/list-quest';
import { environment } from '../../../../environments/environment';
import { StorageService } from '../../../core/services/storage/storage.service';
import { StorageAppKey } from '../../../core/services/storage/enumes/storage-app-key';

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

interface StoredUser {
  id: string;
  is_demo: boolean;
  access_token: string;
  expires: number;
  expire_at: number;
  refresh_token: string;
}

function isStoredUser(value: unknown): value is StoredUser {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const user = value as Record<string, unknown>;
  return typeof user['id'] === 'string'
    && typeof user['is_demo'] === 'boolean'
    && typeof user['access_token'] === 'string'
    && typeof user['expires'] === 'number'
    && typeof user['expire_at'] === 'number'
    && typeof user['refresh_token'] === 'string';
}

@Component({
  selector: 'app-create-game',
  imports: [ NewGame, TranslatePipe, MatButtonToggleModule],
  templateUrl: './create-game.html',
  styleUrl: './create-game.scss'
})
export class CreateGame implements OnInit,OnDestroy {
  private route = inject(ActivatedRoute);
  router = inject(Router);
  templView: string = '';
  
  readonly dialog = inject(MatDialog);
  exit = inject(ExitService);
  subscription: Subscription;
  quests = inject(ListQuest);
  goingPlay: string = '';

  allStatus$ = inject(AllStatus);
  translate = inject(TranslateService);
  txtDialog: any;
  isCreateClick: boolean = false;

  uuid: string = '';
  createNG = inject(NewGameService);
  players = inject(PlayersService);
  notification = inject(NotificationService);
  private storage = inject(StorageService);

  public settings = environment;
  subscriptionCL: Subscription;
  

  ngOnInit(): void {
    this.isCreateClick = false;
    this.allStatus$.setDisplayProgressSpinner(false);
    this.goingPlay = '';
    this.route.params.subscribe(params => {
      this.templView = params['view'];
    });
    this.loadTranslateText();
    this.subscription = this.allStatus$.downTime$.subscribe((follow: any)=>{
      if(follow){
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'nutri-templs';
        dialogConfig.backdropClass = 'nutri-templs-backdrop';
        
        const dialogRef = this.dialog.open(DowntimeWindow, dialogConfig);
        dialogRef.afterClosed().subscribe(result=>{
            this.exit.exitSystem();
        });
      }
    });
    this.subscriptionCL = this.allStatus$.changeLanguage$.subscribe((change: boolean)=>{
      if(change){
        this.allStatus$.setChangeLanguage(false);
        this.loadTranslateText();
      }
    });
  }

  loadTranslateText(){
    this.translate.get(['spinner']).subscribe(translations => {
      this.txtDialog = translations['spinner'];
    });
  }
  
  ngOnDestroy(): void {
    //this.allStatus$.setDisplayProgressSpinner(false);
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    if(this.subscriptionCL){
      this.subscriptionCL.unsubscribe();
    }
  }

  whatGame(game: string){
    this.goingPlay = game;
  }

  isDisabledButton(){
    let isB: boolean = true;
    if(this.goingPlay.length !== 0){
      isB = false;
    }
    return isB;
  }

  goToPrev(){
    this.router.navigate(['/step-one']);
  }

  goToWaiting(){
    const user = this.storage.read<StoredUser>(StorageAppKey.User, isStoredUser);
    this.isCreateClick = true;
    this.quests.clearStorage();
    sessionStorage.setItem("typeGame", JSON.stringify(this.goingPlay));
    sessionStorage.setItem("gamePeople", JSON.stringify('one'));
    this.allStatus$.textSpinner = this.txtDialog.txtCreating;
    this.allStatus$.setDisplayProgressSpinner(true);
    const d = new Date();
    const data = {
      name: `My game room ${d.toLocaleString()}`,
      password: '',
      password_required: false,
      maximum_players: 1,
      type: this.goingPlay
    }
    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'game_create',
      userId: user?.id,
      name: data.name
    });
    this.createNG.createNewGame(data).pipe(
          tap((apartment: any) => this.uuid = apartment.room.uuid),
          exhaustMap((apartment: any)=>  this.players.createPlayerInRoom(apartment.room, true)),
          take(1)          
        ).subscribe({
          next: (data: any)=> {
            this.players.player = data.room;
            this.router.navigate([`/waiting/${this.uuid}`]);
            
          },
          error: (err: any) => {
            this.isCreateClick = false;
            this.allStatus$.setDisplayProgressSpinner(false);
            this.notification.setMessage(err);
            this.notification.display();
          }
        });
  }

}
